import { Transport } from '@studio/models/net';
import type { Aspects } from './types.js';

/** Aspect key literals. */
export const AspectKeys = Object.freeze(['audio', 'control', 'video'] satisfies (keyof Aspects)[]);

/** Language constants. */
export const Lang = Object.freeze({
  transport: {
    [Transport.TCP]: 'TCP',
    [Transport.UDP]: 'UDP'
  } satisfies Record<Transport, string>
});
